import { Injectable } from '@angular/core';
import { ApiService, RepositoryImpl } from '@homeleite/arch';
import { ApplicationLog } from './application-log';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class ApplicationLogsRepository extends RepositoryImpl<ApplicationLog, ApplicationLog> {
    constructor(api: ApiService) {
        super(api.root.path('/application-logs'), ApplicationLog, ApplicationLog);
    }

    public pageProducerLogsBy(
        producerId: string,
        term: string,
        page: number,
        size: number
    ): Observable<ApplicationLog[]> {
        let params = new HttpParams()
            .set('producerId', producerId)
            .set('page', page.toString())
            .set('size', size.toString())
            .set('_actives', 'true');

        if (term && term.trim()) {
            params = params.set('q', term.trim());
        }

        return this.api
            .getJson<any[]>({ params: params })
            .pipe(map((response) => response.map((json) => this.summaryType.fromJson(json))));
    }

    public pageControllerLogsBy(
        controllerId: string,
        term: string,
        page: number,
        size: number
    ): Observable<ApplicationLog[]> {
        let params = new HttpParams()
            .set('controllerId', controllerId)
            .set('page', page.toString())
            .set('size', size.toString())
            .set('_actives', 'true');

        if (term && term.trim()) {
            params = params.set('q', term.trim());
        }

        return this.api
            .getJson<any[]>({ params: params })
            .pipe(map((response) => response.map((json) => this.summaryType.fromJson(json))));
    }
}
